{
  "title": "Finances",
  "description": "Gérez vos revenus, paiements et coordonnées bancaires",
  "tabs": {
    "overview": "Aperçu",
    "transactions": "Transactions",
    "payouts": "Versements",
    "bankDetails": "Coordonnées bancaires"
  },
  "overview": {
    "availableBalance": "Solde disponible",
    "availableBalanceHint": "Solde total des réservations, pourboires et frais",
    "withdrawable": "Retirable",
    "withdrawableHint": "Montant disponible au retrait (min. 20 GH₵)",
    "requestPayout": "Demander un versement",
    "requestingPayout": "Demande en cours...",
    "payoutSuccess": "Versement demandé avec succès",
    "payoutError": "Échec de la demande de versement",
    "recentActivity": "Activité récente",
    "recentActivityHint": "Dernières transactions pour l'entreprise sélectionnée",
    "emptyTransactionsTitle": "Aucune transaction récente",
    "emptyTransactionsDescription": "Les transactions apparaîtront ici dès qu'il y aura de l'activité"
  },
  "income": {
    "documentTitle": "Gestion des revenus",
    "pageTitle": "Gestion des revenus",
    "pageDescription": "Gérez les versements et les coordonnées bancaires",
    "bankDetails": {
      "title": "Coordonnées bancaires",
      "accountLabel": "Compte"
    },
    "withdraw": "Retirer",
    "requesting": "Demande en cours...",
    "metrics": {
      "available": "Disponible",
      "withdrawable": "Retirable"
    },
    "payoutsTitle": "Versements",
    "payouts": {
      "searchPlaceholder": "Rechercher des versements..."
    },
    "toast": {
      "payoutRequested": "Versement demandé avec succès",
      "payoutRequestFailed": "Échec de la demande de versement"
    }
  },
  "bankDetails": {
    "dialogTitle": "Informations du compte de versement",
    "fullName": {
      "label": "Nom complet",
      "hint": "Le nom tel qu'il apparaît sur votre compte bancaire",
      "placeholder": "Jean Dupont"
    },
    "accountNumber": {
      "label": "Numéro de compte",
      "hint": "Votre numéro de compte bancaire (chiffres uniquement)"
    },
    "bank": {
      "label": "Banque",
      "hint": "Sélectionnez votre banque",
      "placeholder": "Sélectionner une banque",
      "searchPlaceholder": "Rechercher des banques...",
      "emptyMessage": "Aucune banque trouvée"
    },
    "submit": "Ajouter le compte",
    "adding": "Ajout...",
    "errors": {
      "fullNameRequired": "Le nom complet est requis",
      "accountNumberRequired": "Le numéro de compte est requis",
      "bankRequired": "Veuillez sélectionner une banque"
    },
    "toast": {
      "addInitiated": "L'ajout du compte de réception de l'entreprise a été initié"
    }
  },
  "transactions": {
    "pageTitle": "Transactions",
    "pageDescription": "Suivez et consultez l’activité récente des transactions",
    "searchPlaceholder": "Rechercher client, ID transaction...",
    "emptyTitle": "Aucune transaction",
    "emptyDescription": "Les transactions apparaîtront ici lorsqu'elles seront disponibles."
  },
  "payouts": {
    "searchPlaceholder": "Rechercher des versements...",
    "emptyTitle": "Aucun versement",
    "emptyDescription": "L'historique des versements apparaîtra ici après un retrait."
  },
  "settings": {
    "payoutAccount": "Compte de versement",
    "payoutAccountHint": "Compte bancaire où les retraits seront envoyés",
    "editBankDetails": "Modifier les coordonnées bancaires",
    "accountNumber": "Numéro de compte",
    "noAccount": "Aucun compte configuré",
    "addAccountHint": "Ajoutez votre compte bancaire pour recevoir les versements des réservations terminées."
  },
  "columns": {
    "customer": "Client",
    "date": "Date",
    "type": "Type",
    "status": "Statut",
    "reference": "Référence",
    "transactionId": "ID transaction",
    "externalReference": "Référence externe"
  },
  "transactionTypes": {
    "all": "Tous",
    "bookingFee": "Frais de réservation",
    "additionalCharge": "Frais supplémentaires",
    "tip": "Pourboire",
    "refund": "Remboursement",
    "subscriptionFee": "Frais d'abonnement",
    "payout": "Versement",
    "platformFee": "Frais de plateforme",
    "adPayout": "Versement publicitaire",
    "adRevenue": "Revenus publicitaires"
  },
  "transactionStatuses": {
    "pending": "En attente",
    "pendingAuthorization": "Autorisation en attente",
    "pendingAny": "En attente",
    "completed": "Terminé",
    "success": "Réussi",
    "failed": "Échoué",
    "cancelled": "Annulé",
    "initiated": "Initié",
    "declined": "Refusé"
  }
}
